import { render, staticRenderFns } from "./LeyendaColorAnexa.vue?vue&type=template&id=7eb22c7a&scoped=true"
var script = {}
import style0 from "./LeyendaColorAnexa.vue?vue&type=style&index=0&id=7eb22c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb22c7a",
  null
  
)

export default component.exports